module.exports = __webpack_public_path__ + "static/media/bg-pattern.9d9b076f.svg";